import React from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';

const getRndInteger = (min, max) => (Math.floor(Math.random() * (max - min + 1)) + min);

const patternVariants = {
  visible: {
    y:  getRndInteger(9,14),
    transition: {
      duration: getRndInteger(1,2), 
      yoyo: Infinity
    }
  }
}

const Wrapper = styled.div`
  position: absolute;
  left: ${props => props.left || 0}%;
  top: ${props => props.top || 0}%;
  transform: rotate(${props => props.angle || '0'}deg) scale(${props => props.scale || 1});
  @media (max-width: 840px) {
    display: none;
  }
`;

export default function SvgWrapper(props){
  return(
    <Wrapper left={props.left} top={props.top} angle={props.angle} scale={props.scale}>
    <motion.div
      variants={patternVariants}
      animate='visible'
    >
        {props.children}
    </motion.div>
    </Wrapper>
  )
}

